import React from 'react';
import { BrowserRouter as Router , Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Pitch from './pages/Pitch';
import About from './pages/About';
import Contact from './pages/Contact';
import Roadmap from './pages/Roadmap';


//import logo from './logo.svg';
import './App.css';

const App = () => {
  return (
    <Router>
      <div className='App'>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pitch" element={<Pitch />} />
        <Route path="/roadmap" element={<Roadmap/>}/>
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      </div>
      <Footer />
    </Router>
  );
};

export default App;
